import { SVGProps } from 'react';

const Building2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18M6 22h12M6 22H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h2m12 10h2a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-2m-8-3h4m-4 4h4m-4 4h4m-4 4h4"
    />
  </svg>
);
export default Building2;
